export default __webpack_public_path__ + "static/media/ASIC.99f7b835.png";